// DO NOT ALTER THIS - IT MUST MATCH SIGNALR CONNECTION STATES
export enum HubConnectionState {
    Connecting = 0,
    Connected = 1,    
    Reconnecting = 2,
    Disconnected = 4
}

export enum SignalRCoreHubConnectionState {
    Connecting = "Connecting",
    Connected = "Connected",
    Reconnecting = "Reconnecting",
    Disconnected = "Disconnected"
}

